import { deleteOffice } from "../api/officeService";

export const useDeleteOffice = (setOffices) => {
    const remove = async (id) => {
        try {
        await deleteOffice(id);
            setOffices((prev) => prev.filter((c) => c.id !== id));
        } catch (error) {
            console.error("Failed to delete office:", error);
            throw error;
        }
    };

    return { remove };
};